import React from 'react'
import { Button, ButtonGroup, Form, Row, Col } from 'react-bootstrap'

const APPLICATIONS = ['oldawg-advisor', 'oldawg-api', 'oldawg-consultant', 'stock-price-lambda', 'technical-calc-lambda']
const STATUS_FILTERS = ['all', 'success', 'failure']

function SreFilters({
  application,
  start,
  end,
  statusFilter,
  onApplicationChange,
  onDateChange,
  onStatusFilterChange,
  onRefresh,
  onReset,
}) {
  return (
    <div className="mb-3">
      <Row className="g-2 align-items-end">
        <Col xs={12} sm="auto">
          <Form.Label htmlFor="sre-application">Application</Form.Label>
          <Form.Select
            id="sre-application"
            value={application}
            onChange={(e) => onApplicationChange(e.target.value)}
          >
            {APPLICATIONS.map((app) => (
              <option key={app} value={app}>
                {app}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={12} sm="auto">
          <Form.Label htmlFor="sre-start">Start</Form.Label>
          <Form.Control
            id="sre-start"
            type="date"
            value={start}
            onChange={(e) => onDateChange('start', e.target.value)}
          />
        </Col>
        <Col xs={12} sm="auto">
          <Form.Label htmlFor="sre-end">End</Form.Label>
          <Form.Control
            id="sre-end"
            type="date"
            value={end}
            onChange={(e) => onDateChange('end', e.target.value)}
          />
        </Col>
        <Col xs={12} sm="auto">
          <Button variant="primary" onClick={onRefresh}>
            Refresh
          </Button>
        </Col>
        <Col xs={12} sm="auto">
          <Button variant="outline-secondary" onClick={onReset}>
            Reset
          </Button>
        </Col>
      </Row>
      <div className="mt-2">
        <ButtonGroup>
          {STATUS_FILTERS.map((filter) => (
            <Button
              key={filter}
              variant={statusFilter === filter ? 'secondary' : 'outline-secondary'}
              className={statusFilter === filter ? 'active' : ''}
              onClick={() => onStatusFilterChange(filter)}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </Button>
          ))}
        </ButtonGroup>
      </div>
    </div>
  )
}

export default SreFilters
